import { languageEn } from "@/i18n/en";
import { languageFr } from "@/i18n/fr";
import { getStateStore, isObjEmpty, isStrEmpty } from "@/utils/utils";

export default {
    data(): any {
        return {};
    },

    methods: {
        getTranslatedText(text: string, xargs: any = {}) {
            if (!text) {
                return;
            }
            const store = getStateStore();
            const lang = store.lang;

            const language: { [key: string]: string } =
                lang === "fr" ? languageFr : languageEn;

            const rsText = text.toLowerCase();
            let translatedText: any = !isStrEmpty(language[rsText])
                ? language[rsText]
                : rsText.charAt(0).toUpperCase() + rsText.slice(1);

            if (!isObjEmpty(xargs)) {
                for (const key in xargs) {
                    const regex = new RegExp(`\\[${key}\\]`, "g");
                    translatedText = translatedText.replace(
                        regex,
                        xargs[key]
                    );
                }
            }

            return translatedText;
        },
    },
};
